/**
 * Fetches and renders custom sections for a given page and location.
 * Used on Transportation, Energy & Buildings, and People pages so Local Government content appears at the bottom.
 */

import React, { useEffect, useState } from 'react';
import { fetchCustomSections, type CustomSectionPageId } from '../../services/customSectionsService';
import { CustomSectionBlock } from './CustomSectionBlock';

interface CustomSectionsForPageProps {
  pageId: CustomSectionPageId;
  locationName: string;
}

export const CustomSectionsForPage: React.FC<CustomSectionsForPageProps> = ({ pageId, locationName }) => {
  const [sections, setSections] = useState<Awaited<ReturnType<typeof fetchCustomSections>>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!locationName) {
      setSections([]);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    fetchCustomSections(locationName, pageId).then((data) => {
      if (!cancelled) {
        setSections(data);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [locationName, pageId]);

  if (loading || sections.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      {sections.map((section) => (
        <CustomSectionBlock key={section.id} section={section} />
      ))}
    </div>
  );
};

export default CustomSectionsForPage;
